import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
import { MapPin } from 'lucide-react';
import { SEO } from '../utils/seo';
export function EmploiPage() {
  const jobs = [{
    title: 'Réceptionniste',
    hours: '09:00 am - 04:00 pm',
    type: 'Full time',
    location: 'Agadir'
  }, {
    title: 'Chef de cuisine',
    hours: '09:00 am - 05:00 pm',
    type: 'Full time',
    location: 'Agadir'
  }, {
    title: "Gouvernante d'hôtel",
    hours: '09:00 am - 04:00 pm',
    type: 'Full time',
    location: 'Agadir'
  }, {
    title: "Maître d'hôtel",
    hours: '09:00 am - 06:00 pm',
    type: 'Full time',
    location: 'Agadir'
  }];
  return <div className="min-h-screen bg-white" data-id="element-366">
      <SEO title="Emploi" description="Offres d'emploi dans l'hôtellerie à Agadir - Réceptionniste, Chef de cuisine, Gouvernante, Maître d'hôtel. Rejoignez notre réseau d'excellence" keywords="emploi hôtellerie Agadir, offres emploi tourisme, recrutement hôtels Agadir, carrière hôtellerie Maroc" data-id="element-367" />
      <Navbar data-id="element-368" />

      {/* Hero */}
      <section className="bg-arih-blue py-24 md:py-32" data-id="element-369">
        <div className="container mx-auto px-4 md:px-8 text-center" data-id="element-370">
          <h1 className="text-[48px] md:text-[70px] font-semibold text-white leading-tight mb-6" data-id="element-371">
            Emploi
          </h1>
          <p className="text-[20px] text-white/90 leading-[32px] max-w-2xl mx-auto" data-id="element-372">
            Vous êtes passionné(e) par l'hôtellerie et avez le sens du service
            exceptionnel ? Rejoignez notre réseau exclusif.
          </p>
        </div>
      </section>

      {/* Join Network Section */}
      <section className="bg-white py-[120px]" data-id="element-373">
        <div className="container mx-auto px-4 md:px-8" data-id="element-374">
          <div className="max-w-3xl mx-auto text-center space-y-6" data-id="element-375">
            <h2 className="text-[40px] md:text-[48px] font-bold text-arih-dark" data-id="element-376">
              Rejoignez notre réseau
            </h2>
            <p className="text-[18px] text-arih-gray leading-[32px]" data-id="element-377">
              Vous êtes passionné(e) par l'hôtellerie et avez le sens du service
              exceptionnel ? Rejoignez notre réseau exclusif et profitez d'une
              expérience enrichissante. Faites le premier pas vers une carrière
              prometteuse au sein de nos membres et partenaires !
            </p>
            <p className="text-[18px] text-arih-gray leading-[32px]" data-id="element-378">
              Nous vous invitons à envoyer votre candidature spontanée dès
              maintenant à l'adresse suivante :
            </p>
            <a href="mailto:contact@arihasm.ma" className="inline-block text-[22px] font-bold text-arih-blue hover:underline" data-id="element-379">
              contact@arihasm.ma
            </a>
          </div>
        </div>
      </section>

      {/* Job Listings */}
      <section className="bg-arih-light-bg py-20 px-4 md:px-8" data-id="element-380">
        <div className="container mx-auto" data-id="element-381">
          <h2 className="text-[36px] md:text-[40px] font-bold text-arih-dark mb-12" data-id="element-382">
            Offres en cours
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-383">
            {jobs.map((job, index) => <Card key={index} className="bg-white rounded-xl shadow-sm border-0" data-id="element-384">
                <CardContent className="p-7" data-id="element-385">
                  <h3 className="text-[22px] font-bold text-arih-dark mb-3" data-id="element-386">
                    {job.title}
                  </h3>
                  <div className="space-y-2 mb-4" data-id="element-387">
                    <p className="text-[16px] text-arih-gray" data-id="element-388">{job.hours}</p>
                    <p className="text-[16px] text-arih-gray" data-id="element-389">{job.type}</p>
                    <p className="text-[16px] text-arih-gray flex items-center gap-2" data-id="element-390">
                      <MapPin className="h-4 w-4" data-id="element-391" />
                      {job.location}
                    </p>
                  </div>
                  <a href="mailto:contact@arihasm.ma" data-id="element-392">
                    <Button className="bg-arih-blue text-white rounded-full px-7 py-2.5 h-auto text-[16px] font-semibold hover:bg-blue-800 transition-colors" data-id="element-393">
                      Postuler
                    </Button>
                  </a>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </section>

      <Footer data-id="element-394" />
    </div>;
}